export const ERROR_TYPES = [
  { name: 'Missing required fields, please try again.', code: '1' },
  { name: 'Some values are out of range', code: '2' },
  { name: 'Permission denied', code: '3' },
  { name: 'Character limit reached', code: '4' },
  { name: 'Incorrect format values', code: '5' },
  { name: 'Could not get the file', code: '6' }
];
